/* eslint-disable @nx/enforce-module-boundaries */
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  cleanDownloadedFile,
  downloadDiskFile,
  downloadDiskFolder,
  downloadFile,
  finishFileDownload,
} from 'v4/store/actions/myDisk.Action';

let interuptDownload = false;
export const useDownloadFile = ({ file: selectedFile }) => {
  const [downloading, setDownloading] = useState(false);
  const [downloadedPercent, setDownloadedPercent] = useState(0);
  const dispatch = useDispatch();

  /**
   * download as file in browser
   * @param {*} file
   * @param {*} filename
   */
  const download = async (file, filename) => {
    const url = window.URL.createObjectURL(file);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  /**
   * Handler download operation
   */
  const onDownload = async () => {
    // console.log(selectedFile, 'asdf file');
    
    // if(selectedFile?.type==="D"){
    //   setDownloading(true);
    //   dispatch(downloadDiskFolder({folderId:selectedFile?.id}));
    //   const { data } = await axios({
    //       url: selectedFile?.file,
    //       method: 'GET',
    //       responseType: 'blob',
    //       onDownloadProgress: ({ loaded, total, estimated, ...rest }) => {
    //         const progress = Math.round(
    //           ((isNaN(loaded) ? 0 : loaded) * 100) /
    //             (total ? total : selectedFile?.size ?? 1)
    //         );

    //         setDownloadedPercent(progress);
    //       },
    //     });
    //   await download(data, selectedFile?.name);
    // }

    if (selectedFile && selectedFile.id) {
      const url = new URL(selectedFile.file);
      const extn = url?.pathname?.substring(url?.pathname?.lastIndexOf('.'));
      try {
        setDownloading(true);
        dispatch(downloadDiskFile({fileId:selectedFile?.id, parentId:selectedFile?.parent}));
        const { data } = await axios({
          url: selectedFile?.file,
          method: 'GET',
          responseType: 'blob',
          onDownloadProgress: ({ loaded, total, estimated, ...rest }) => {
            const progress = Math.round(
              ((isNaN(loaded) ? 0 : loaded) * 100) /
                (total ? total : selectedFile?.size ?? 1)
            );

            setDownloadedPercent(progress);
          },
        });
        await download(data, selectedFile?.name);
        setDownloading(false);
      } catch (e) {
        console.error(e);
      } finally {
        setDownloading(false);
      }
    }
  };

  /**
   * Stop download
   */
  const onStop = () => {
    if (downloading) {
      dispatch(finishFileDownload());
      dispatch(cleanDownloadedFile());
      setDownloadedPercent(0);
      interuptDownload = true;
    }
  };

  return {
    downloading,
    downloadedPercent,
    onDownload,
    onStop,
  };
};
